import type { MinhaEmpresa } from '@entregas/api';
import { createContext, useContext } from 'react';

// A loja do usuário, garantida pelo guarda <RequerLoja>: dentro do painel nunca é nula.
export const ContextoLoja = createContext<MinhaEmpresa | null>(null);

export function useLoja(): MinhaEmpresa {
  const loja = useContext(ContextoLoja);
  if (!loja) throw new Error('useLoja precisa estar dentro de <RequerLoja>.');
  return loja;
}
